import styled from "styled-components";
import {JackpotBetWidgetShadowOverlayDefaultBox} from "./jackpot-bet-widget-shadow-overlay.default.box";

export const JackpotBetWidgetShadowOverlayMRGBox = styled(JackpotBetWidgetShadowOverlayDefaultBox)`
  box-shadow: 0px 0px 24px 8px #262627 inset;
  display: initial;
`;
